export class ViewsTypes {
    static Requests = "Requests";
    static PlaysStarted = "Plays Started";
    static PlaysCompleted = "Plays Completed";
}


// WEBPACK FOOTER //
// ./src/app/dashboard/views/views.types.ts